import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-stream-modal',
  templateUrl: './no-stream-modal.component.html',
  styleUrls: ['./no-stream-modal.component.scss']
})
export class NoStreamModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
